import { createReducer } from 'utils/redux';
import { Map } from 'immutable';
import { actionTypes } from './actions';

const initialState = Map({
  loading: false,
  error: '',
  data: null,
  filter: '',
});

const onStartFetchTabsStatus = (state) => state.set('loading', true);

const onSuccessFetchTabsStatus = (state, { payload }) =>
  state.set('loading', false).set('data', payload).set('error', '');

const onErrorFetchTabsStatus = (state, { payload }) =>
  state.set('loading', false).set('error', payload);
const onChangeFilter = (state, { payload }) => state.set('filter', payload);

export default createReducer(initialState, {
  [actionTypes.TABS_STATUS_REQUEST_START]: onStartFetchTabsStatus,
  [actionTypes.TABS_STATUS_REQUEST_SUCCESS]: onSuccessFetchTabsStatus,
  [actionTypes.TABS_STATUS_REQUEST_FAILURE]: onErrorFetchTabsStatus,
  [actionTypes.TABS_STATUS_CHANGE_FILTER_VALUE]: onChangeFilter,
});
